module.exports = __webpack_public_path__ + "img/kycdone.9bc1b53f.svg";